import {useState, useMemo, useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// -
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import TabBasic from "./MQTT/TabBasic";
import TabAdvanced from "./MQTT/TabAdvanced";
import axiApi from "ApiCaller";

const ViewMQTT = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tc} = useTranslation("choices");

    document.title = "MQTT";
    const bread = useMemo(
        () => [
            {
                name: _Tr("labels.advanced"),
                url: "/advanced/",
                current: false,
            },
            {name: document.title, current: true},
        ],
        [_Tr]
    );
    const [models, setModels] = useState([]);
    const [keyTab, setKeyTab] = useState("basic");
    const [searchParams] = useSearchParams();
    useEffect(() => {
        axiApi.get("/api/devices/network/mqtts/modes/").then((resp) => {
            if (resp.data.status) {
                setModels([...resp.data.models]);
                if (searchParams.get("t") === "a") {
                    setKeyTab("advanced");
                }
            }
        });
    }, []);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <Tabs
                activeKey={keyTab}
                id="mqtt-tabs"
                onSelect={(k) => setKeyTab(k)}
                className="mb-3 mt-1 nav-tabs-fs-15">
                <Tab eventKey="basic" title={_Tc("mqttTypes.b")} className="nuevo">
                    <TabBasic />
                </Tab>
                {models.includes("MQ2-4G") && (
                    <Tab eventKey="advanced" title={_Tc("mqttTypes.a")}>
                        <TabAdvanced />
                    </Tab>
                )}
            </Tabs>
        </>
    );
};
export default ViewMQTT;
